import React, { Suspense, useEffect, useState } from "react";
import ViewerComponent from "./modules/3dViewer/ViewerComponent";
import { ViewerProvider } from "./context/ViewerContext";

import DropArea from "./modules/DropArea/DropArea";
import MapLoader from "./modules/loader/MapLoader";
import CreateDataSource from "./modules/createDataSource/CreateDataSource";
import TimeLineComponent from "./modules/timeline/TimeLineComponent";
import ToolbarComponent from "./modules/ToolbarComponent";
import SceneLoader from "./modules/SceneLoader/SceneLoader";

function CesiumViewerContent({ callback }) {
    const options = {
        initialPosition: { x: -3798513.7641457906, y: 4789070.356086788, z: -1826854.6870554422 }
    };

    return (
        <>
            <ViewerComponent options={options} callback={callback}>
                <MapLoader status={false} />
                <ToolbarComponent/>
                <CreateDataSource />
                <TimeLineComponent/>
            </ViewerComponent>
            <DropArea />
            <SceneLoader />
        </>
    );
}

function CesiumViewer({ callback }) {
    const [loaded, setLoaded] = useState(true);

    return (
        <>
            {loaded && (
                <ViewerProvider>
                    <CesiumViewerContent callback={callback} />
                </ViewerProvider>
            )}
        </>
    );
}

export default CesiumViewer;
